import { useCurrentUser } from '../queries/currentUser';

export const useUserGroup = (): string | undefined => {
  const { data: user } = useCurrentUser();
  return user?.primary_group;
};
